import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=923e29bc&scoped=true&"
import script from "./classification.vue?vue&type=script&lang=js&"
export * from "./classification.vue?vue&type=script&lang=js&"
import style0 from "./classification.vue?vue&type=style&index=0&id=923e29bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e29bc",
  null
  
)

export default component.exports